module.exports = __webpack_public_path__ + "static/img/1.0a6e8da4.png";